import * as React from "react";

interface EditableSectionContentProps {
    children?: React.ReactNode;
}

class EditableSectionContent extends React.Component<EditableSectionContentProps> {
    render() {
        return this.props.children || null;
    }
}

export default EditableSectionContent;